import { ReactNode } from 'react';
import { FeatureFlagProviderCreator, KnownFlags, LocalFlagConfiguration } from './shared';

export const CreateLaunchDarklyProvider: FeatureFlagProviderCreator = () => {
  return Promise.resolve(({ children }: { children: ReactNode }) => {
    return <div>{children}</div>;
  });
};

export const useFlags = (flagName: KnownFlags | KnownFlags[]) => {
  const overrides = (typeof window !== 'undefined' && (window as any).__CYPRESS_FLAG_OVERRIDES__) || {};

  if (Array.isArray(flagName)) {
    return flagName.reduce((acc, flag) => {
      return {
        ...acc,
        [flag]: flag in overrides ? overrides[flag] : LocalFlagConfiguration[flag],
      };
    }, {});
  }

  return flagName in overrides ? overrides[flagName] : LocalFlagConfiguration[flagName];
};
